import {Modal} from "react-bootstrap";
import styles from "./style.module.css"
import AnimeForm from "../../../forms/animeForm";
import {isUserAdmin} from "../../../services/authService";

type Props = {
    isOpen?: boolean;
    onClose: () => void;
}

const AnimeModal = ({
    isOpen = false,
    onClose
}: Props) => {
    const isAdminUser = isUserAdmin();

    if (!isAdminUser) {
        return <></>;
    }

    return (
        <Modal
            show={isOpen}
            onHide={onClose}
            dialogClassName={styles.Dialog}
            contentClassName={styles.Content}
            scrollable={true}
            id="animeModal"
        >
            <Modal.Body>
                <div className="row">
                    <div className="col-md-12">
                        <AnimeForm onClose={onClose} type="New" />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default AnimeModal;
